import { getAccount } from '@wagmi/core';
import { resolveWalletConnector } from '../service/resolveWalletConnector';
export function createEVMGaslessProvider(config, supportsNetwork) {
    return {
        supportsNetwork,
        async signGaslessDeposit({ address, typedData, wallet }) {
            if (!typedData)
                throw new Error('Missing typed data for gasless deposit');
            if (!address)
                throw new Error('No selected account');
            const connector = wallet ? resolveWalletConnector(config, { ...wallet, address }) : getAccount(config).connector;
            const walletProvider = await connector?.getProvider();
            if (!walletProvider?.request)
                throw new Error('Wallet provider unavailable');
            const signature = await walletProvider.request({
                method: 'eth_signTypedData_v4',
                params: [address, JSON.stringify(typedData)],
            });
            if (typeof signature !== 'string')
                throw new Error('Invalid signature returned by wallet');
            return signature;
        }
    };
}
